<template>
  <b-modal v-model="show" ref="showUpdateTournamentModal" size="lg" centered header-bg-variant="primary" hide-footer title="Update Tournament" @show="showModal" @hide="$emit('cancelUpdate')">
    <div class="d-block">
      <b-row>
        <b-col sm="12" v-if="show">
          <b-row>
            <b-col sm="4">
              <p-input v-model="form.PeriodNumber" label="Period Number" name="PeriodNumber" :handler="$v" :formData="form" type="text"/>
            </b-col>
            <b-col sm="8">
              <p-input v-model="form.Name" label="Tournament Name" name="Name" :handler="$v" :formData="form" type="text"/>
            </b-col>
            <b-col sm="6">
              <p-input v-model="form.StartTime" label="Start Time" name="StartTime" :handler="$v" :formData="form" type="date" :helptext="SETTING['timezone']"/> <br/>
            </b-col>
            <b-col sm="6">
              <p-input v-model="form.EndTime" label="End Time" name="EndTime" :handler="$v" :formData="form" type="date" :helptext="SETTING['timezone']"/>
            </b-col>
            <b-col sm="6">
              <p-dropdown v-model="form.Brand" label="Brand" name="Brand" :loading="fetchingBrand" :handler="$v" :formData="form" :options="brandList" textKey="Code" textValue="Name" @change="getGameList(form.Brand)" />
            </b-col>
            <b-col sm="6">
              <p-multiselect v-model="form.Games" label="Select Games" name="Games" :loading="fetchingGames" :handler="$v" :formData="form" :options="gameList" textKey="GameId" textValue="GameName" />
            </b-col>
            <b-col sm="6">
              <p-image v-model="form.Image" label="Update Image" name="Image" :handler="$v" :formData="form" type="text"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-button variant="success" @click="updateTournament">Update</b-button>
    <b-button variant="outline-danger" @click="$emit('cancelUpdate')">Cancel</b-button>
  </b-modal>
</template>

<script>

import VueNotifications from 'vue-notifications'
import {Events} from '../../../events.js'
import { PInput, PDropdown, PMultiselect, PImage } from '../../../components'
const {required} = require('vuelidate/lib/validators')
const moment = require('moment-timezone')

export default {
  data: () => {
    return {
      tournament: {},
      updateId: '',
      fetchingBrand: false,
      fetchingGames: false,
      gameList: [],
      form: {
        PeriodNumber: '',
        Name: '',
        Image: '',
        StartTime: '',
        EndTime: '',
        Brand: '',
        Games: [],
        errorMessages: {
          PeriodNumber: {
            required: 'Period Number is required'
          },
          Name: {
            required: 'Tournament Name is required'
          },
          Image: {
            required: 'Image is required'
          },
          StartTime: {
            required: 'StartTime is required'
          },
          EndTime: {
            required: 'EndTime is required'
          },
          Brand: {
            required: 'Brand is required'
          },
          Games: {
            required: 'Must have atleast one game'
          }
        }
      }
    }
  },
  computed: {
    show: {
      get: function () {
        return this.showUpdateModal
      },
      set: function () {
        return this.showUpdateModal
      }
    }
  },
  props: {
    brandList: {
      type: Array
    },
    showUpdateModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: {}
    }
  },
  validations: {
    form: {
      PeriodNumber: {required},
      Name: {required},
      Image: {required},
      StartTime: {required},
      EndTime: {required},
      Brand: {required},
      Games: {required}
    }
  },
  components: {
    PInput,
    PDropdown,
    PMultiselect,
    PImage
  },
  methods: {
    async showModal () {
      try {
        this.updateId = this.updateData.Id
        this.form.PeriodNumber = this.updateData.PeriodNumber
        this.form.Name = this.updateData.Name
        this.form.Image = this.updateData.ImageUrl
        this.form.StartTime = moment(this.updateData.StartTime).format('YYYY-MM-DD')
        this.form.EndTime = moment(this.updateData.EndTime).format('YYYY-MM-DD')
        this.form.Brand = this.updateData.Brand
        this.form.Games = this.updateData.GameId
        await this.getGameList(this.updateData.Brand)
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async getGameList (brand) {
      try {
        this.fetchingGames = true
        let { data } = await this.$http.get(this.API_ENDPOINT + '/game/gamelist?brand=' + brand, { headers: { 'Content-Type': 'application/json' } })
        this.gameList = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.fetchingGames = false
      }
    },
    async updateTournament () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        let gameId = this.form.Games.reduce((prev, next) => { return prev + `${next.GameId}, ` }, '')
        gameId = gameId.slice(0, gameId.lastIndexOf(','))
        let formData = new FormData()
        formData.append('PeriodNumber', this.form.PeriodNumber)
        formData.append('Name', this.form.Name)
        formData.append('Image', this.form.Image)
        formData.append('StartTime', this.form.StartTime)
        formData.append('EndTime', this.form.EndTime)
        formData.append('Brand', this.form.Brand)
        formData.append('GameId', gameId)
        await this.$http.put(this.API_ENDPOINT + `/tournament/main/updateTournament/${this.updateId}`, formData, { headers: { 'Content-Type': 'application/json' } })
        this.$emit('cancelUpdate')
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Tournament Updated Successfully.')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/tournament/MainTournament/UpdateTournament.vue